import { createContext } from "react";
import type { ExonnApi } from "@exonn/js-sdk";

export const ExonnApiContext = createContext<null | ExonnApi>(null);
